import { useMemo } from 'react'
import type { SafeApp as SafeAppData } from '@safe-global/store/gateway/AUTO_GENERATED/safe-apps'
import { Errors, logError } from '@/services/exceptions'
import { fetchSafeAppFromManifest } from '@/services/safe-apps/manifest'
import useAsync from '@safe-global/utils/hooks/useAsync'
import { getEmptySafeApp } from '@/components/safe-apps/utils'
import type { SafeAppDataWithPermissions } from '@safe-global/views/components/safe-apps/types'
import { asError } from '@safe-global/utils/services/exceptions/utils'

type UseSafeAppFromManifestReturnType = {
  safeApp: SafeAppDataWithPermissions
  isLoading: boolean
}

const useSafeAppFromManifest = (
  appUrl: string,
  chainId: string,
  safeAppData?: SafeAppData,
): UseSafeAppFromManifestReturnType => {
  const [data, , isLoading] = useAsync<SafeAppDataWithPermissions>(() => {
    if (!appUrl || !chainId || !safeAppData) return

    return fetchSafeAppFromManifest(appUrl, chainId).catch((e) => {
      logError(Errors._903, `${appUrl}, ${asError(e).message}`)
      throw e
    })
  }, [appUrl, chainId, safeAppData])

  const emptyApp = useMemo(() => getEmptySafeApp(appUrl, safeAppData), [appUrl, safeAppData])

  return { safeApp: data || emptyApp, isLoading }
}

export { useSafeAppFromManifest }
